import { render } from "./narvar2_ingles.vue?vue&type=template&id=2be43831&scoped=true"
import script from "./narvar2_ingles.vue?vue&type=script&lang=js"
export * from "./narvar2_ingles.vue?vue&type=script&lang=js"

import "./narvar2_ingles.vue?vue&type=style&index=0&id=2be43831&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be43831"]])

export default __exports__